import React, { useMemo } from 'react'

import { ButtonCtr } from 'common/builder/components/chart/FlowChart/components/Button/ButtonCtr/ButtonCtr'
import { NextStepWrapper } from 'common/builder/components/chart/FlowChart/components/Button/NextStepWrapper/NextStepWrapper'
import { ButtonContentComponent } from 'common/builder/components/chart/FlowChart/components/Button/types'
import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

import * as styles from './DefaultButtonContent.styles'

const ButtonConnectorOffset =
  sharedStyles.Spacings.MEDIUM + sharedStyles.Spacings.NODE_HORIZONTAL_PADDING

export const DefaultButtonContent: ButtonContentComponent = ({ button }) => {
  const IconComponent = button.icon
  const iconString = useMemo(
    () =>
      IconComponent
        ? convertToIconString(IconComponent, {
            color: sharedStyles.Colors.PRIMARY,
            size: sharedStyles.IconSizes.MEDIUM * 2,
          })
        : null,
    [IconComponent],
  )

  return (
    <view style={styles.wrapper}>
      <view style={styles.textContainer}>
        <richtext style={styles.textStyle} text={button.caption} />
      </view>
      <ButtonCtr button={button} />
      <view style={styles.infoWrapper}>
        {iconString && <sprite style={styles.iconSpriteStyle} image={iconString} />}
        {button.nextStep && (
          <NextStepWrapper>
            <NextStep nextStep={button.nextStep} connectorOffsetX={ButtonConnectorOffset} />
          </NextStepWrapper>
        )}
      </view>
    </view>
  )
}
